import * as yup from 'yup'

const schema = yup.object().shape({
  riskLevel: yup.number().required(),
})

export default schema
